function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCoderDojoLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 275 275",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "logo"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path19",
    d: "M136.962,0c75.632,0 136.942,61.31 136.942,136.943c0,75.632 -61.31,136.942 -136.942,136.942c-75.633,0 -136.943,-61.31 -136.943,-136.942c-0,-75.633 61.31,-136.943 136.943,-136.943Zm-1.384,7.084c-0.641,0 -1.281,0.013 -1.922,0.026c-70.815,1.025 -127.962,58.799 -127.962,129.846c-0,71.135 57.275,128.949 128.206,129.845c-35.075,-0.884 -63.258,-29.63 -63.258,-64.91c0,-35.843 29.093,-64.935 64.936,-64.935c35.843,-0 64.936,-29.093 64.936,-64.936c-0,-35.844 -29.093,-64.936 -64.936,-64.936Zm-11.273,224.053l12.426,0l-0,-47.718l-12.221,-0c-1.127,-0 -2.075,-0.397 -2.87,-1.179c-0.794,-0.781 -1.178,-1.742 -1.178,-2.869c-0,-1.115 0.397,-2.076 1.178,-2.857c0.782,-0.782 1.743,-1.179 2.87,-1.179l20.317,0l0,55.815l8.096,0l0,-16.846c0,-1.088 0.397,-2.036 1.179,-2.843c0.781,-0.807 1.742,-1.205 2.856,-1.205c1.128,0 2.089,0.398 2.87,1.179c0.781,0.794 1.179,1.742 1.179,2.869l-0,20.894c-0,1.127 -0.398,2.088 -1.179,2.883c-0.781,0.781 -1.729,1.165 -2.87,1.165l-32.653,0c-1.127,0 -2.075,-0.41 -2.857,-1.217c-0.794,-0.82 -1.178,-1.793 -1.178,-2.92c-0,-1.089 0.397,-2.025 1.178,-2.806c0.782,-0.769 1.742,-1.153 2.857,-1.153l-0,-0.013Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path17",
    d: "M115.081,84.792l0,-48.411c0,-2.113 0.769,-3.945 2.319,-5.482c1.537,-1.538 3.369,-2.319 5.496,-2.319l25.236,-0c2.088,-0 3.895,0.769 5.419,2.319c1.524,1.537 2.28,3.369 2.28,5.482l0,48.411c0,2.152 -0.768,3.984 -2.28,5.508c-1.524,1.525 -3.369,2.28 -5.521,2.28l-25.134,0c-2.178,0 -4.036,-0.755 -5.547,-2.28c-1.512,-1.524 -2.255,-3.356 -2.255,-5.508l-0.013,-0Zm32.757,-0.295l-0,-47.718l-24.66,-0l-0,47.718l24.66,0Z",
    style: {
      fill: "#fff"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoderDojoLogo);
export default __webpack_public_path__ + "static/media/CoderDojo_logo.7e1f1827eaf9be21eff12dcc1303175b.svg";
export { ForwardRef as ReactComponent };